import {
  INIT_COMPANY_LIST_REQUEST,
  SET_COMPANY_LIST,
  ERROR_COMPANY_LIST,
  ADD_COMPANY,
  SET_COMPANY,
  UPDATE_COMPANY,
  ERROR_COMPANY,
  DELETE_COMPANY
} from './action';

const initialState = {
  data: [],
  error: null,
  isLoading: false,
  selectedCompany: null,
};

const companyListReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_COMPANY_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case SET_COMPANY_LIST:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null,
      };

    case ERROR_COMPANY_LIST:
      return {
        ...state,
        data: [],
        isLoading: false,
        error: action.payload,
      };

    case ERROR_COMPANY:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case ADD_COMPANY:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case UPDATE_COMPANY:
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case SET_COMPANY:
      return {
        ...state,
        isLoading: false,
        selectedCompany: action.payload,
        error: null,
      };
      case DELETE_COMPANY:
        return {
          ...state,
          isLoading: false,
          error: null,
        };
      
      

    default:
      return state;
  }
};

export default companyListReducer;
